import { z } from 'zod';

export const featureFlagSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  state: z.enum(['TESTING', 'RELEASED', 'RETIRED']),
  enabledForAll: z.boolean(),
  enabledForMe: z.boolean(),
});
export type FeatureFlag = z.infer<typeof featureFlagSchema>;

export const featureFlagUserSchema = z.object({
  userId: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  isSiOverlord: z.boolean(),
  enabled: z.boolean(),
});

export interface CreateFeatureFlag {
  key: string;
  name: string;
  description: string;
}
